import { getCurrentTenantDomain } from "./utils/tenant";

const TENANT_SUGGESTIONS = {
  ccg: [
    {
      group: "Positive Trends",
      items: [
        {
          label: "Company",
          prompt:
            "Analyze Company performance for positive trends (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "RSM",
          prompt:
            "Analyze RSM performance for positive trends (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "ASM",
          prompt:
            "Analyze ASM performance for positive trends (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "State",
          prompt:
            "Analyze State performance for positive trends (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "Store",
          prompt:
            "Analyze Store performance for positive trends (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "Fitter",
          prompt:
            "Analyze Fitter performance for positive trends (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
      ],
    },
    {
      group: "Areas of Concern",
      items: [
        {
          label: "Company",
          prompt:
            "Analyze Company performance for negative trends, areas of opportunity to improve or areas of concern (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "RSM",
          prompt:
            "Analyze RSM performance for negative trends, areas of opportunity to improve or areas of concern (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "ASM",
          prompt:
            "Analyze ASM performance for negative trends, areas of opportunity to improve or areas of concern (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "State",
          prompt:
            "Analyze State performance for negative trends, areas of opportunity to improve or areas of concern (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "Store",
          prompt:
            "Analyze Store performance for negative trends, areas of opportunity to improve or areas of concern (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
        {
          label: "Fitter",
          prompt:
            "Analyze Fitter performance for negative trends, areas of opportunity to improve or areas of concern (receipts, fittings, avg sale and additional correlated metrics) month to date",
        },
      ],
    },
  ],
  excelsia: [
    {
      label: "Visits by month by source system (2025 vs. 2026)",
      prompt:
        "Show me the number of visits by month for each combined source system, comparing 2025 vs. 2026, using service date. Include a percentage change column between the two years",
    },
    {
      label: "Total amount by source system and category (2021–2025)",
      prompt:
        "For each combined source system and each category, show the total amount using posting date, pivoting the years as columns. Show only the years from 2021 to 2025",
    },
    {
      label: "Top 5 CPT codes by market (rolling 3 years, charges only)",
      prompt:
        "Show me the top 5 most used CPT codes for each market for rolling 3 years, based on service date, for charges only",
    },
  ],
};

const DEFAULT_SUGGESTIONS = [
  "Show me recent data",
  "What trends can you find?",
  "Summarize key metrics",
  "Compare this period vs last",
  "What are the top performers?",
  "Find patterns in our data",
];

/**
 * Returns suggestions in normalized grouped format:
 * [{ group: string | null, items: [{ label, prompt }] }]
 */
export function getAiSuggestions() {
  const tenant = getCurrentTenantDomain();
  const raw = TENANT_SUGGESTIONS[tenant] || DEFAULT_SUGGESTIONS;
  if (!raw.length) return [];

  // Already grouped format
  if (raw[0]?.group) return raw;

  // Flat list — wrap in a single ungrouped group
  const items = raw.map((item) =>
    typeof item === "string" ? { label: item, prompt: item } : item
  );
  return [{ group: null, items }];
}
